import { Panel } from '@cinch-nx/landing-ui-shared'
import { Secondary } from '@cinch-nx/landing-ui-shared'
import Link from 'next/link'
import { JargonPreviewStory } from '../../types'
import styles from './related-jargon.module.css'

export interface RelatedJargonProps {
  items: JargonPreviewStory[]
}
export const RelatedJargon: React.FC<RelatedJargonProps> = ({ items }) => (
  <div className={styles.related} data-testid="jargon-list">
    {items.length > 0 &&
      items
        .filter((item) => item && item.content)
        .map((item, index) => (
          <Panel
            title={item.content?.question}
            subtitle={item.content?.summary}
            isPadded={true}
            key={index}
          >
            <div className={styles.link}>
              <Link href={`/jargon/${item.slug}`} passHref legacyBehavior>
                <Secondary
                  element="a"
                  data-testid="jargonLink"
                  className={styles.button}
                >
                  Read more
                </Secondary>
              </Link>
            </div>
          </Panel>
        ))}
  </div>
)
